import { Lookup, useLookup } from '@/providers'
import { useQuery } from '@api/hooks'
import { Autocomplete, Stack, TextField } from '@mui/material'
import MarketBasketsApi, { MarketBasketsKeys } from '@services/marketBaskets.api'
import { useParams } from 'react-router-dom'
import { StringParam, useQueryParam } from 'use-query-params'

export default function SalesforceExclusionFilters() {
	const { marketBasketId } = useParams()

	const [customer, setCustomer] = useQueryParam('exclusionCustomer', StringParam)
	const [manufacturer, setManufacturer] = useQueryParam('exclusionManufacturer', StringParam)
	const [enabled, setEnabled] = useQueryParam('exclusionEnabled', StringParam)
	const [program, setProgram] = useQueryParam('exclusionProgram', StringParam)
	const [source, setSource] = useQueryParam('exclusionSource', StringParam)

	const programTypes = useLookup(Lookup.ProgramTypes)
	const enabledFilters = useLookup(Lookup.EnabledFilters)

	const { data: salesforceExclusionsCustomers } = useQuery({
		queryKey: MarketBasketsKeys.salesforceExclusionsCustomers(marketBasketId),
		queryFn: () => MarketBasketsApi.salesforceExclusionsCustomers(marketBasketId),
		enabled: !!marketBasketId,
	})

	const { data: salesforceExclusionsManufacturers } = useQuery({
		queryKey: MarketBasketsKeys.salesforceExclusionsManufacturers(marketBasketId),
		queryFn: () => MarketBasketsApi.salesforceExclusionsManufacturers(marketBasketId),
		enabled: !!marketBasketId,
	})

	const { data: salesforceExclusionsSources } = useQuery({
		queryKey: MarketBasketsKeys.salesforceExclusionsSources(marketBasketId),
		queryFn: () => MarketBasketsApi.salesforceExclusionsSources(marketBasketId),
		enabled: !!marketBasketId,
	})

	return (
		<Stack direction="row" spacing={2}>
			<Autocomplete
				sx={{ flex: 6 }}
				fullWidth
				size="small"
				options={salesforceExclusionsCustomers || []}
				value={salesforceExclusionsCustomers?.find((option) => option.id === customer) || null}
				onChange={(_, newValue) => {
					setCustomer(newValue?.id?.toString() || null)
				}}
				renderInput={(params) => <TextField {...params} label="Customer" />}
			/>
			<Autocomplete
				sx={{ flex: 6 }}
				fullWidth
				size="small"
				options={salesforceExclusionsManufacturers || []}
				value={
					salesforceExclusionsManufacturers?.find((option) => option.id === manufacturer) || null
				}
				onChange={(_, newValue) => {
					setManufacturer(newValue?.id?.toString() || null)
				}}
				renderInput={(params) => <TextField {...params} label="Manufacturer" />}
			/>
			<Autocomplete
				sx={{ flex: 3 }}
				fullWidth
				size="small"
				options={programTypes || []}
				value={programTypes?.find((option) => option.id === program) || null}
				onChange={(_, newValue) => {
					setProgram(newValue?.id?.toString() || null)
				}}
				renderInput={(params) => <TextField {...params} label="Program" />}
			/>
			<Autocomplete
				sx={{ flex: 6 }}
				fullWidth
				size="small"
				options={salesforceExclusionsSources || []}
				value={salesforceExclusionsSources?.find((option) => option.id === source) || null}
				onChange={(_, newValue) => {
					setSource(newValue?.id?.toString() || null)
				}}
				renderInput={(params) => <TextField {...params} label="Source" />}
			/>
			<Autocomplete
				sx={{ flex: 3 }}
				fullWidth
				size="small"
				options={enabledFilters || []}
				value={enabledFilters?.find((option) => option.id === enabled) || null}
				onChange={(_, newValue) => {
					setEnabled(newValue?.id?.toString() || null)
				}}
				renderInput={(params) => <TextField {...params} label="Enabled" />}
			/>
		</Stack>
	)
}
